import React from "react";
import { Trans } from "react-i18next";
const NxTrans = (props) => React.createElement(Trans, Object.assign({}, props));
export default NxTrans;
//# sourceMappingURL=NxTrans.js.map